import {
    VIDEO_UPLOAD_ACCEPT_EXTENSIONS,
    VIDEO_UPLOAD_ACCEPT_MIMETYPES,
} from '../../../constants/videoUploadAcceptTypes';
import { getFileExtension } from '../../../libs/utils/getFileExtension';
import { matchMimeType } from '../../../libs/utils/matchMimeType';
import { validateFileSignature } from '../../../libs/utils/validateFileSignature';

type VideoFileFilterResult = {
    validFiles: File[];
    invalidCount: number;
};

export async function filterValidVideoFiles(files: File[]): Promise<VideoFileFilterResult> {
    const validFiles: File[] = [];
    let invalidCount = 0;

    for (const file of files) {
        const isFileAcceptedByMime = VIDEO_UPLOAD_ACCEPT_MIMETYPES.some((acceptedMimetype) =>
            matchMimeType(acceptedMimetype, file.type),
        );

        const fileExtension = getFileExtension(file.name);
        const isFileAcceptedByExtension = VIDEO_UPLOAD_ACCEPT_EXTENSIONS.includes(fileExtension);

        if (isFileAcceptedByMime) {
            validFiles.push(file);
        } else if (isFileAcceptedByExtension) {
            const isValidSignature = await validateFileSignature(file);

            if (isValidSignature) {
                validFiles.push(file);
            } else {
                invalidCount++;
            }
        } else {
            invalidCount++;
        }
    }

    return { validFiles, invalidCount };
}
